import { Text } from "@mantine/core";
import { useAppSelector } from "app/hooks";
import { selectBundles } from "features/admin/catalog/Catalog.slice";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { BundleForm } from "../BundleForm";

export const EditBundle = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const bundle = useAppSelector(selectBundles)
    .filter((bundle) => bundle.id === id)
    .at(0);

  if (!bundle) {
    return <Text>{t("NOT_FOUND")}</Text>;
  }

  return <BundleForm bundle={bundle} />;
};
